/**
  *  @fileOverview: 首页-数据统计
  *  @creator: CaoYanqi
  *  @Date: 2019/6/5
  *  @Last Modified by: 
  *  @Last Modified time:
  */
import { hasPermission } from '@lima/seraphim-react'
import { Col, Popover, Row } from 'antd'
import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { SYSTEMPermission } from "../../../permissions/system"
import './dataCount.less'


class DataCount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
    this.content = (
      <div className="data_count_po_tips">
        <p className="title">统计规则：</p>
        <p className="desc">按承保时间统计昨日0点～24时，包含当前账户及所有下级机构团队。</p>
        <p className="title marTop24">新单量：</p>
        <p className="desc">统计时间段内已支付出单件数-已撤单件数-已退保件数</p>
        <p className="title marTop24">保费：</p>
        <p className="desc">统计时间段内已支付保费-已撤单保费-已退保保费</p>
        <p className="title marTop24">推广费：</p>
        <p className="desc">统计时间段内已支付的获得-已撤单扣减-已退保扣减</p>
      </div>
    );
  }

  componentDidMount() {
  }

  render() {
    return (
      <div className="data_count_wrap" style={{ minHeight: 130 }}>
        <div className="header" style={{ display: "none" }}>
          <div className="title">数据统计
            {
              // ？提示，第三方不展示
              !(this.props.pageConfig && this.props.pageConfig.extendBtnClose) &&
              <Popover placement="bottomLeft" title='' content={this.content} trigger="hover">
                <div className="count_tips"></div>
              </Popover>
            }
          </div>
          <Link to={'/policySys/onlinePolicy'}>线上保单</Link>
        </div>
        <Row gutter={24} key="r1">
        <Col span={8} key="c1">
              <div className="data_card">
                <div className="card_title">昨日新单量</div>
                <p><span>{this.props.yesterdayPolicyCount || 0}</span> 件</p>
              </div>
            </Col>
            <Col span={8} key="c2">
              <div className="data_card">
                <div className="card_title">昨日保费</div>
                <p><span>{this.props.yesterdayPremiumSum || '0.00'}</span> 元</p>
              </div>
            </Col>
            <Col span={8} key="c3">
              <div className="data_card">
                <div className="card_title">昨日机构收入</div>
                <p><span>{this.props.yesterdayPromotionFee || '0.00'}</span> 元</p>
              </div>
            </Col>
        </Row>
        {
          !(this.props.pageConfig && this.props.pageConfig.extendBtnClose) && hasPermission(SYSTEMPermission.ORGREPORTM) &&
          <Link to="/businessReport/orgReportM" className="expand_btn">查看全部</Link>
        }
      </div>
    )
  }
}

function mapState(state) {
  return {
    token: state.token
  }
}

export default connect(mapState)(DataCount)
